import { render, staticRenderFns } from "./OfficeCell.vue?vue&type=template&id=1d740ffa"
import script from "./OfficeCell.vue?vue&type=script&lang=js"
export * from "./OfficeCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports